module.exports = __webpack_public_path__ + "img/portfolio-09.7dae3def.jpg";